import { organisationConstants } from '../../_constants/organisation.constants';
const initialState = { set_expiry_loading : true, set_expiry: '', set_expiry_error: false};

export function setExpiryDate(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_SET_EXPIRY:
        return {
            set_expiry_loading: true,
            set_expiry: '',
            set_expiry_error: false
        };
      case organisationConstants.RESPONSE_SET_EXPIRY:
        return {
            set_expiry_loading: false,
            set_expiry: action.set_expiry,
            set_expiry_error: false
        };
      case organisationConstants.ERROR_SET_EXPIRY:
        return { 
            set_expiry_loading: false,
            set_expiry: '',
            set_expiry_error: true
        };
      default:
        return state
    }
}



// WEBPACK FOOTER //
// ./src/_reducers/organisation/setExpiryDate.reducer.js